import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';
import { FormField } from '../forms/form-field.model';
import { TextFieldComponent } from '../forms/text-field.component';
import { QCNamingConventions } from './qc-naming-conventions/qc-naming-conventions';
import { QCNamingConvention } from './qc-naming-conventions/qc-naming-convention';

@Component({
  selector: 'app-qc-submit-dialog',
  templateUrl: './qc-submit-dialog.component.html',
  styleUrls: ['./qc-submit-dialog.component.scss']
})
export class QCSubmitDialogComponent implements OnInit {

  button: string;
  currentReportName: string;
  field: FormField;
  namingConvention: QCNamingConvention;
  recipients: any[];
  reportName: string;
  title: string;
  workflowId: number;

  @ViewChild("reportNameField") reportNameField: TextFieldComponent;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.recipients = this.data.recipients != null ? this.data.recipients : [];
    this.workflowId = this.data.workflowId;

    this.currentReportName = this.data.reportName

    this.namingConvention = QCNamingConventions.conventionForComponents({
      aspectRatio: this.data.aspectRatio,
      domesticEpisode: this.data.domesticEpisode,
      elementType: this.data.elementType,
      foreignEpisode: this.data.foreignEpisode,
      format: this.data.format,
      houseNumber: this.data.houseNumber,
      language: this.data.language,
      programTitle: this.data.programTitle,
      revision: this.data.revision,
      standard: this.data.standard,
      status: this.data.status,
      version: this.data.version,
      videoBitRate: this.data.videoBitRate,
      videoBitRateUnits: this.data.videoBitRateUnits,
    })


    this.reportName = this.namingConvention != null ?
      this.namingConvention.generatedName : this.currentReportName;
  }

  onReportNameChange(event) {
    this.reportName = event.value;
  }

  onCheckboxChange(event) {
    let checked = event.value
    if (checked) {
      this.reportNameField.setValue(this.namingConvention.generatedName, false)
      this.reportNameField.disable();
    } else {
      this.reportNameField.enable();
    }
  }

  onRecipientsChange(event) {
    this.recipients = event.value;
  }

  onClose() {
    let emails: string[] = [];
    for (let r of this.recipients) {
      r = r.stored
      if (r.users != null) {
        // Distribution list
        for (let u of r.users) {
          emails.push(u.email);
        }
      } else {
        emails.push(r.email);
      }
    }
    return {recipients: emails, reportName: this.reportName}
  }

}

class ReportNameComponents {
  aspectRatio: string;
  episode: string;
  format: string;
  programTitle: string;
  standard: string;

  constructor(init?:Partial<ReportNameComponents>) {
    if (init.aspectRatio != null) {
      this.aspectRatio = this.formatted(init.aspectRatio)
        .replace(/_[A-Z]+$/, '');
    }
    this.episode = this.formatted(init.episode);
    this.format = this.formatted(init.format);
    this.standard = this.formatted(init.standard);
    let programTitle = this.formatted(init.programTitle)
    if (programTitle != null) {
      let match = programTitle.match(/\((\w+)\)$/);
      this.programTitle = match != null ? match[1] : null;
    } 
  }

  get generatedName(): string {
    let components = [this.aspectRatio, this.episode, this.format, this.programTitle, this.standard]
    let blankComponents = components.filter((x) => x == null || x.trim() == '')
    if (blankComponents.length > 0) { return null }
    return this.episode + '_' + this.format + '_' + this.standard + '_' + this.aspectRatio + '_' + this.programTitle;
  }

  private formatted(component: string) {
    if (component == null) { return null };
    return component.toUpperCase().replace(/[\s\-]/g,'_').replace(/[\.\:]/g,'')
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc-submit-dialog.component.ts